// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import amendmentEntity from './entities/amendment.json';
import amendmentMenu from '../pages/amendment/menu.json';
import amendmentFullForm from '../pages/amendment/forms/full.json';
import amendmentContextForm from '../pages/amendment/forms/context.json';
import amendmentMiniForm from '../pages/amendment/forms/mini.json';
import amendmentLookupForm from '../pages/amendment/forms/lookup.json';
import amendmentTableView from '../pages/amendment/views/table.json';
import amendmentStagesView from '../pages/amendment/views/stages.json';
import amendmentBacklogView from '../pages/amendment/views/backlog.json';
import amendmentSplitView from '../pages/amendment/views/split.json';
import amendmentCardsView from '../pages/amendment/views/cards.json';
import amendmentCalendarView from '../pages/amendment/views/calendar.json';
import amendmentDashboardView from '../pages/amendment/views/dashboard.json';

/** Тип запису «Поправка» зі сторінками пакета: меню, форми та подання з pages/amendment/. */
export const amendmentDefinition: IRecordTypeDefinition = {
  ...amendmentEntity,
  views: assembleViewSet({
      table: amendmentTableView,
      stages: amendmentStagesView,
      backlog: amendmentBacklogView,
      split: amendmentSplitView,
      cards: amendmentCardsView,
      calendar: amendmentCalendarView,
      dashboard: amendmentDashboardView,
  }),
  form: amendmentFullForm,
  forms: { full: amendmentFullForm, context: amendmentContextForm, mini: amendmentMiniForm, lookup: amendmentLookupForm },
  menu: amendmentMenu,
} as IRecordTypeDefinition;
